import React, { useState } from "react";
import { FaEye, FaEyeSlash, FaRegEye } from "react-icons/fa";

interface IProps {
  text: string;
  firstLetters?: number;
  bulletQuantity?: number;
}

const HiddenText: React.FC<IProps> = ({
  text,
  firstLetters = 0,
  bulletQuantity = 5,
}) => {
  const [hidden, setHidden] = useState(true);
  const [hover, setHover] = useState(false);

  const hiddenFunc = (val: any): string => {
    var text: string = val.toString();
    text =
      text.substring(0, firstLetters) +
      " " +
      "•".repeat(bulletQuantity - firstLetters.toString().length);
    return text;
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div>{hidden ? hiddenFunc(text) : text}</div>
      <div
        className="ms-2"
        style={{
          display: "flex",
          cursor: "pointer",
        }}
        onClick={() => setHidden(!hidden)}
      >
        {hidden ? hover ? <FaEye /> : <FaRegEye /> : <FaEyeSlash />}
      </div>
    </div>
  );
};

export default HiddenText;
